"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var dateMath = require("../util/date-arithmetic");
var localizers_1 = require("../util/localizers");
var _1 = require("../util/_");
var widget_helpers_1 = require("../util/widget-helpers");
var vdl_prefix_1 = require("../util/vdl-prefix");
var format = function (props) { return localizers_1.date.getFormat('decade', props.decadeFormat); };
var isEqual = function (dateA, dateB) { return dateMath.eq(dateA, dateB, 'decade'); };
var optionId = function (id, date) { return id + "__century_" + dateMath.getYear(date); };
function inRangeDate(decade, min, max) {
    return dateMath.max(dateMath.min(decade, max), min);
}
function inRange(decade, min, max) {
    return dateMath.gte(decade, dateMath.startOf(min, 'decade'), 'year')
        && dateMath.lte(decade, dateMath.endOf(max, 'decade'), 'year');
}
function inCentury(date, start) {
    return dateMath.gte(date, dateMath.startOf(start, 'century'), 'year')
        && dateMath.lte(date, dateMath.endOf(start, 'century'), 'year');
}
function getCenturyDecades(_date) {
    var days = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    var date = dateMath.add(dateMath.startOf(_date, 'century'), -20, 'year');
    return days.map(function () { return (date = dateMath.add(date, 10, 'year')); });
}
var Century = /** @class */ (function (_super) {
    __extends(Century, _super);
    function Century() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._row = function (row, rowIdx) {
            var _a = _this.props, focused = _a.focused, disabled = _a.disabled, onChange = _a.onChange, readOnly = _a.readOnly, value = _a.value, today = _a.today, culture = _a.culture, min = _a.min, max = _a.max;
            var id = widget_helpers_1.instanceId(_this, '_century');
            return (React.createElement("tr", { key: 'row_' + rowIdx, role: "row" }, row.map(function (date, colIdx) {
                var _a;
                var isFocused = isEqual(date, focused);
                var isSelected = isEqual(date, value);
                var currentDecade = isEqual(date, today);
                var label = localizers_1.date.format(dateMath.startOf(date, 'decade'), format(_this.props), culture);
                var empty = !inRange(date, min, max);
                var currentID = optionId(id, date);
                var cellClassNames = (_a = {},
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade')] = true,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--off-range')] = !inCentury(date, focused),
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--readonly')] = readOnly,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--disabled')] = disabled,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--focus')] = isFocused,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--selected')] = isSelected,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--now')] = currentDecade,
                    _a[vdl_prefix_1.vdlPrefix('calendar__decade--empty')] = empty,
                    _a);
                var nonInteractive = empty || disabled || readOnly;
                return (React.createElement("td", { key: colIdx, role: "gridcell", id: currentID, title: label, "aria-selected": isSelected, "aria-label": label, "aria-readonly": nonInteractive, className: classnames_1.classNames(cellClassNames), onClick: nonInteractive ? undefined : onChange.bind(null, inRangeDate(date, min, max)) },
                    React.createElement("span", { "aria-labelledby": currentID }, label)));
            })));
        };
        return _this;
    }
    Century.prototype.componentDidUpdate = function () {
        var onAriaActiveDescendant = this.props.onAriaActiveDescendant;
        var activeId = optionId(widget_helpers_1.instanceId(this), this.props.focused);
        if (onAriaActiveDescendant) {
            onAriaActiveDescendant(activeId);
        }
    };
    Century.prototype.render = function () {
        var _a = this.props, className = _a.className, focused = _a.focused, onKeyDown = _a.onKeyDown;
        var years = getCenturyDecades(focused);
        var rows = _1.chunk(years, 4);
        var elementProps = _1.omit(this.props, Object.keys(Century.propTypes));
        return (React.createElement("table", __assign({}, elementProps, { onKeyDown: onKeyDown, role: "grid", className: className }),
            React.createElement("tbody", null, rows.map(this._row))));
    };
    Century.propTypes = {
        culture: PropTypes.string,
        value: PropTypes.instanceOf(Date),
        focused: PropTypes.instanceOf(Date).isRequired,
        min: PropTypes.instanceOf(Date).isRequired,
        max: PropTypes.instanceOf(Date).isRequired,
        today: PropTypes.instanceOf(Date),
        onChange: PropTypes.func.isRequired,
        decadeFormat: PropTypes.any,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        onAriaActiveDescendant: PropTypes.func
    };
    return Century;
}(React.PureComponent));
exports.Century = Century;
